(function ($, window, document,) {
    "use strict";
    var $win = $(window);
    var $doc = $(document);
    var $body = $('body');


    $('.accordion').on('click', '.accordion-control', function(e) {
        e.preventDefault();
        $(this).next('.accordion-panel').not(':animated').slideToggle();
    });


    var single_product_slider = $('.single_product-slider');
    if (single_product_slider.length > 0) {
        single_product_slider.slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 40,
            arrows: true,
            prevArrow: '<div class="slick-arrow-fix slick-left"><i class="icofont-thin-left"></i></div>',
            nextArrow: '<div class="slick-arrow-fix slick-right"><i class="icofont-thin-right"></i></div>'
        });
    }

    $('.modal-toggle').on('click', function(e) {
        e.preventDefault();
        $('.product-modal').toggleClass('is-visible');
    });


        // $win.load(function () {
        //     var product_single_media =  $('.product-single__media-group'),
        //         single_product_content =  $('.single-product__content'),
        //         product_height = product_single_media.length ? product_single_media.find('.product-single__thumbnail').height() : 0;
        //
        //     console.log($('.product-single__thumbnail').height());
        //     single_product_content.css({height:product_height,'position':'relative'})
        // });
        //
        //




    $(document).ready(function () {
        $(document).click(function () {
            if ($('.single-option-label-toggle').hasClass('open')) {
                $('.single-option-panel').removeClass('open').slideUp();
                setTimeout(function(){
                    $('.single-option-label-toggle').removeClass('open');
                }, 500);
            }
        });


        $('.single-option-label-toggle').click(function (e) {
            e.stopPropagation();
            $(this).addClass('open');
            $(this).siblings(".single-option-panel").slideToggle(
                function(){
                    if ($(this).hasClass('open')){
                        $(this).removeClass('open');
                        $(this).parents('.product-form__item_wrap').find('.single-option-label-toggle').removeClass('open');
                    }else{
                        $(this).addClass('open');
                        $(this).parents('.product-form__item_wrap').find('.single-option-label-toggle').addClass('open');
                    }
                }
            );
        });
        $('.single-option-panel').click(function (e) {
            e.stopPropagation();
        });
    });



    $('.single-option-panel li').on('click', function (event) {
        $(this).siblings('.active').removeClass('active');
        $(this).addClass('active');
        event.preventDefault();
        var data_value = $(this).attr('data-value');
        $('.single-option-label-toggle').text(data_value);
        $(this).parents('.single-option-panel').removeClass('open').slideUp();
        setTimeout(function(){
            $('.single-option-label-toggle').removeClass('open');
        }, 500);
        $("#SingleOptionSelector option").val(data_value).change();
    });

    $(document).ready(function() {
        var first_data_value = $('.single-option-panel li:first-child').attr('data-value');
        console.log( first_data_value );
        $('.single-option-label-toggle').text(first_data_value);
        $("#SingleOptionSelector option").val(first_data_value).change();
    });


})(jQuery, window, document);
